import React, { useEffect, useState } from "react";
import { Card, Table, Row, Col, Tooltip, Button, message, Checkbox, } from "antd";
import { EditFilled, DeleteFilled, FormOutlined } from "@ant-design/icons";
import { isValidValue, setFormFieldValue } from "../../../../helpers/FormHelper";
import { getErrorMessage } from "../../../../helpers/ErrorHelper";
import { useSelector } from "react-redux";
import moment from "moment";
import ConfirmDelete from "../../../../components/Common/Modals/ConfirmDelete";
import { EmptyTable } from "../../../Election/Patronage/PatronageReferred/voters-list/components/List";
import ErrorCard from "../../../../components/Common/Cards/ErrorCard";
import DiasporaReferenceService from "../../../../services/Diaspora/DiasporaReferenceService";
import { getFullName } from "../../../../helpers/ObjectHelper";



const getReferuesName = (reference) => {
    const referuesName = setFormFieldValue(reference?.referues_name);
    const referuesSurname = setFormFieldValue(reference?.referues_surname);

    if (isValidValue(referuesName) && isValidValue(referuesSurname)) {
        return referuesName + " " + referuesSurname;
    }

    if (isValidValue(referuesName)) {
        return referuesName;
    }

    return null;
};



const List = ({ dispatch, items, totalCount, initialPagination, loading, errorMessage, setLoadingType, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [selectedReference, setSelectedReference] = useState(null);
    const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);


    const selectedReferenceName = getFullName(selectedReference?.voter);


    const [paginationTable, setPaginationTable] = useState({
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 15, 20, 25],
        pageSize: initialPagination.pageSize,
        current: initialPagination.currentPage,
        total: totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
    });


    useEffect(() => {
        setPaginationTable({
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 15, 20, 25],
            pageSize: initialPagination.pageSize,
            current: initialPagination.currentPage,
            total: totalCount,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
    }, [initialPagination, totalCount]);


    const handleTableChange = (pagination, filters, sorter) => {
        setLoadingType(null);
        const action = {
            type: "set_table_pagination",
            payload: {
                pageSize: pagination.pageSize,
                currentPage: pagination.current,
            },
        };
        dispatch(action);
    };


    const tableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            width: 70,
            align: "center",
            render: (value) => <b>{value + "."}</b>,
        },
        {
            title: "Emri",
            dataIndex: "name",
            align: 'left',
            width: 150,
            render: (_, elm) => setFormFieldValue(elm?.voter?.name)
        },
        {
            title: "Mbiemri",
            dataIndex: "surname",
            align: 'left',
            width: 150,
            render: (_, elm) => setFormFieldValue(elm?.voter?.surname)
        },
        {
            title: "Atësia",
            dataIndex: "father_name",
            align: 'left',
            width: 150,
            render: (_, elm) => setFormFieldValue(elm?.voter?.father_name)
        },
        {
            title: "Datëlindja",
            dataIndex: "dob",
            align: 'center',
            width: 130,
            render: (_, elm) => isValidValue(elm?.voter?.dob) ? moment(elm?.voter?.dob).format("DD-MM-YYYY") : null
        },
        {
            title: "Shteti i emigracionit",
            dataIndex: "country",
            width: 200,
            render: (text, record) => setFormFieldValue(record?.country?.country_name),
        },
        {
            title: "Tipi i referencës",
            dataIndex: "reference_type",
            width: 150,
            render: (text, record) => setFormFieldValue(record?.reference_type?.label),
        },
        {
            title: "Qarku",
            dataIndex: "region",
            width: 200,
            render: (text, record) => setFormFieldValue(record?.voter?.region?.name),
        },
        {
            title: "Bashkia",
            dataIndex: "municipality",
            width: 250,
            render: (text, record) => setFormFieldValue(record?.voter?.municipality?.alias),
        },
        {
            title: "Nj. administrative",
            dataIndex: "unit",
            width: 280,
            render: (text, record) => setFormFieldValue(record?.voter?.unit?.name),
        },
        {
            title: "Telefoni",
            dataIndex: "phone",
            align: "center",
            width: 170,
            render: (text, record) => setFormFieldValue(record?.emigrant_phone),
        },
        {
            title: "Evidenca",
            dataIndex: "evidenca",
            align: "center",
            width: 150,
            render: (text, record) => <Checkbox checked={record?.evidenca} />,
        },
        {
            title: "Regjistruar në PER",
            dataIndex: "per_registered",
            align: "center",
            width: 150,
            render: (text, record) => <Checkbox checked={record?.per_registered} />,
        },
        {
            title: "Ka marrë zarfin",
            dataIndex: "envelope_received",
            align: "center",
            width: 150,
            render: (text, record) => <Checkbox checked={record?.envelope_received} />,
        },
        {
            title: "Ka votuar",
            dataIndex: "voted",
            align: "center",
            width: 100,
            render: (text, record) => <Checkbox checked={record?.voted} />,
        },
        {
            title: "Referuesi",
            dataIndex: "referues_name",
            align: "left",
            width: 200,
            render: (text, record) => getReferuesName(record),
        },
        {
            title: "Dt. e regjistrimit",
            dataIndex: "create_date",
            align: "center",
            width: 150,
            render: (text, record) => moment(record?.create_date).format("DD-MM-YYYY, HH:mm"),
        },
        {
            title: "Veprime",
            dataIndex: "actions",
            align: "center",
            width: 140,
            fixed: "right",
            className: "bg-white m-0 p-0",
            render: (_, elm) => (
                <div className="p-2" style={{ backgroundColor: "#fff" }}>
                    <Tooltip title="Azhorno statusin e votimit">
                        <Button
                            type="primary"
                            className="mr-2"
                            style={{ color: "#ffffff", backgroundColor: "#FF9421", borderColor: "#FF9421" }}
                            onClick={() => openView(elm, 3)}
                            icon={<EditFilled />}
                        />
                    </Tooltip>
                    <Tooltip title="Modifiko të dhënat">
                        <Button
                            type="primary"
                            className="mr-2"
                            onClick={() => openView(elm, 2)}
                            icon={<FormOutlined />}
                        />
                    </Tooltip>
                    <Tooltip title="Fshi">
                        <Button
                            danger
                            onClick={() => showDeleteModal(elm)}
                            icon={<DeleteFilled />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];


    const showDeleteModal = (item) => {
        setSelectedReference(item);
        setConfirmDeleteModal(true);
    };


    const openView = (item, index) => {
        const action = {
            type: 'open_view',
            payload: {
                item: item,
                index: index
            }
        };
        dispatch(action);
    };


    const onDelete = async () => {
        try {
            setDeleteLoading(true);
            const referenceId = setFormFieldValue(selectedReference?.id);
            const response = await DiasporaReferenceService.delete(token, referenceId);
            const responseData = response.data;
            console.log('RESPONSE DATA: ', responseData);
            await message.success('Fshirja u krye me sukses!');
            setConfirmDeleteModal(false);
            onSuccess();
        } catch (error) {
            const errorMessage = getErrorMessage(error);
            await message.error(errorMessage, 2);
        } finally {
            setDeleteLoading(false);
        }
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card style={{ borderRadius: "0", marginBottom: '0' }} bodyStyle={{ padding: "0" }}>
                            <div className="table-responsive">
                                <Table
                                    size="small"
                                    className="striped-table"
                                    columns={tableColumns}
                                    rowKey="id"
                                    loading={loading}
                                    dataSource={items}
                                    pagination={paginationTable}
                                    onChange={handleTableChange}
                                    scroll={{ x: 1500 }}
                                    showHeader="true"
                                    locale={{
                                        emptyText: errorMessage ? (
                                            <ErrorCard message={errorMessage} />
                                        ) : (
                                            EmptyTable
                                        ),
                                    }}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <ConfirmDelete
                            isOpen={confirmDeleteModal}
                            title="Jeni të sigurtë që dëshironi të fshini referencën e zgjedhur?"
                            subtitle={selectedReferenceName}
                            isLoading={deleteLoading}
                            onConfirm={onDelete}
                            onClose={() => setConfirmDeleteModal(false)}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default List;
